import { getPhoenixUrl as getSharedPhoenixUrl } from "@ecologi/shared";

export const getPhoenixUrl = () => {
  return getSharedPhoenixUrl(process.env.NEXT_PUBLIC_DEPLOYMENT);
};
